import { Component, ErrorHandler, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { Router } from '@angular/router'
import { KirjautunutTilintarkastajaService } from 'app/_angular/service/kirjautunut-tilintarkastaja.service'

@Component({
  standalone: false,
  templateUrl: './tilintarkastaja-kirjautuminen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../login/login.component.css', './tilintarkastaja-kirjautuminen.component.css'],
})
export class TilintarkastajaKirjautuminenComponent implements OnInit {
  /** Virhe tunnistautumisessa */
  readonly tunnistautuminenVirhe = signal(false)

  /** Kirjaudutaan sisään custom tokenilla */
  readonly kirjaudutaanSisaan = signal(false)

  year = new Date().getFullYear()

  data: { lemonatorToken: string; lemonaidToken: string }

  constructor(
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _kirjautunutTilintarkastajaService: KirjautunutTilintarkastajaService,
  ) {
    this.data = this._router.currentNavigation()?.extras?.state as { lemonatorToken: string; lemonaidToken: string }
  }

  async ngOnInit() {
    if (this.data && this.data.lemonatorToken && this.data.lemonaidToken) {
      this.kirjaudutaanSisaan.set(true)
      try {
        await this._kirjautunutTilintarkastajaService.kirjauduCustomTokenilla(this.data.lemonatorToken, this.data.lemonaidToken)
      } catch (error) {
        this._errorHandler.handleError(error)
        this.tunnistautuminenVirhe.set(true)
        this.kirjaudutaanSisaan.set(false)
      }
    }
    // Muuten näytetään näkymä normaalisti
  }
}
